
// @ts-nocheck


export const localeCodes =  [
  "en-us",
  "de-de"
]

export const localeLoaders = {
  "en-us": [
    {
      key: "locale_index_46ts_a87fbe69",
      load: () => import("#nuxt-i18n/a87fbe69" /* webpackChunkName: "locale_index_46ts_a87fbe69" */),
      cache: false
    }
  ],
  "de-de": [
    {
      key: "locale_index_46ts_e468dbf0",
      load: () => import("#nuxt-i18n/e468dbf0" /* webpackChunkName: "locale_index_46ts_e468dbf0" */),
      cache: false
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en-us",
      label: "English",
      language: "en",
      isCatchallLocale: false,
      flag: "united-states.svg",
      files: [
        "/app/i18n/translations/en_US/index.ts"
      ]
    },
    {
      code: "de-de",
      label: "Deutsch",
      language: "de",
      isCatchallLocale: false,
      flag: "germany.svg",
      files: [
        "/app/i18n/translations/de_DE/index.ts"
      ]
    }
  ],
  defaultLocale: "de-de",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: "append",
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix",
  lazy: true,
  langDir: "translations/",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "https://gokonfetti.com",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  ignoreRoutes: [
    "/api/**"
  ],
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en-us",
    label: "English",
    language: "en",
    isCatchallLocale: false,
    flag: "united-states.svg",
    files: [
      {
        path: "/app/i18n/translations/en_US/index.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "de-de",
    label: "Deutsch",
    language: "de",
    isCatchallLocale: false,
    flag: "germany.svg",
    files: [
      {
        path: "/app/i18n/translations/de_DE/index.ts",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/